import { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { store } from 'redux/store';
import {
  selectMeteorologyAgroWBCultureSelectedChartVariables,
  setChart as setChartRedux,
} from 'redux/reducers/meteorologyAgroWBCultureReducer';
import useOptions from './useOptions';

export default function useChartVariable() {
  const { options, isLoading } = useOptions();
  const chartOptions = useMemo(() => (options ? options.variables.map((variable) => ({
    id: variable.id,
    name: variable.name,
    label: variable.label,
  })) : []), [options]);
  const selectedChartVariables: number[] = useSelector(
    selectMeteorologyAgroWBCultureSelectedChartVariables,
  );

  const toggleChartVariables = (id: number) => {
    const newChart = selectedChartVariables.includes(id)
      ? selectedChartVariables.filter((c) => c !== id)
      : selectedChartVariables.concat(id);
    newChart.sort();
    store.dispatch(setChartRedux(newChart));
  };

  const selectAll = useCallback(() => {
    store.dispatch(setChartRedux(chartOptions.map((c) => c.id)));
  }, [chartOptions]);

  const deselectAll = useCallback(() => {
    store.dispatch(setChartRedux([]));
  }, []);

  const allSelected = useMemo(() => (
    chartOptions.every((option) => selectedChartVariables.includes(option.id))
  ), [chartOptions, selectedChartVariables]);

  return {
    chartOptions,
    toggleChartVariables,
    selectAll,
    deselectAll,
    allSelected,
    selectedChartVariables,
    isLoading,
  };
}
